import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  flagAddressButton: {
    defaultMessage: 'Flag Address',
    description: 'Button text to flag an address for fraud',
    id: 'atW3Jv',
  },
  flagAddressTooltip: {
    defaultMessage:
      'This will add the address to the blacklist and block it and all future orders with this address from shipping without manual override.',
    description: 'Tooltip explaining what flagging an address does',
    id: '4P0UeF',
  },
  alreadyBlacklistedTooltip: {
    defaultMessage: 'This address is already blacklisted',
    description: 'Tooltip shown when address is already in the blacklist',
    id: 'bwAZsW',
  },
  flagAddressSuccess: {
    defaultMessage: 'Address flagged successfully',
    description: 'Success notification when address is flagged',
    id: 'a0to4v',
  },
  flagAddressError: {
    defaultMessage: 'Failed to flag address',
    description: 'Error notification when flagging address fails',
    id: 'FrsOAz',
  },
  header: {
    defaultMessage: 'Flag Address for Fraud',
    description: 'Header for flag address modal',
    id: 'MNUvRu',
  },
  description: {
    defaultMessage: 'This will add the address to the blacklist and prevent future orders from shipping without manual override.',
    description: 'Description text for flag address modal',
    id: 'xLgSD6',
  },
  reasonLabel: {
    defaultMessage: 'Why is this address being flagged?',
    description: 'Label for reason input in flag address modal',
    id: 'UX4ehz',
  },
  reasonRequiredError: {
    defaultMessage: 'Reason is required.',
    description: 'Error message when reason is not provided',
    id: 'Ly7+LK',
  },
  reasonMaxLengthError: {
    defaultMessage: 'Reason cannot exceed 500 characters.',
    description: 'Error message when reason exceeds maximum length',
    id: 'gQRdZ9',
  },
  flagAddress: {
    defaultMessage: 'Flag Address',
    description: 'Submit button text for flag address modal',
    id: 'tn7/0L',
  },
  flagging: {
    defaultMessage: 'Flagging...',
    description: 'Submit button text while flagging is in progress',
    id: '7agJZd',
  },
});
